/* cSpell:ignore regexify */

import React from 'react';
import type { TextProps } from 'react-native';
import { Text } from 'react-native';
import regexifyString from 'regexify-string';

import { TextLink } from '../../TextLink';

export const TextLinkify = (props: TextLinkifyProps) => (
  <Text>{linkifyText(props.children, props.regex)}</Text>
);

export const TextLinkifyTags = ({
  children,
  links,
  ...rest
}: TextLinkifyTagsProps) => (
  <Text {...rest}>{linkifyTags(children, links)}</Text>
);

// ─── UTILS ──────────────────────────────────────────────────────────────────────

function linkifyText(text: string, urlRegex = /(((https?:\/\/)|(www\.))\S+)/g) {
  return regexifyString({
    pattern: urlRegex,
    decorator: (url, index) => (
      <TextLink key={index} href={withHttpsProtocol(url)}>
        {url}
      </TextLink>
    ),
    input: text,
  }).filter(withoutEmptyStrings);
}

const linkifyTags = (text: string, links: TextLinkifyTagsProps['links']) =>
  regexifyString({
    pattern: /{(.+?)}/g,
    decorator(tag, index) {
      const currentTag = links.find((link) => link.tag === tag.slice(1, -1));

      return currentTag ? (
        <TextLink key={index} href={currentTag.href} newTab={currentTag.newTab}>
          {currentTag.description}
        </TextLink>
      ) : (
        ''
      );
    },
    input: text,
  }).filter(withoutEmptyStrings);

function withoutEmptyStrings(chunk: string | React.ReactElement) {
  return chunk !== '';
}

export function withHttpsProtocol(url: string) {
  if (url.startsWith('http')) return url;

  return `https://${url}`;
}

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type TextLinkifyProps = TextProps & {
  readonly children: string;
  readonly regex?: RegExp;
};

type TextLinkifyTagsProps = TextProps & {
  readonly children: string;
  readonly links: ReadonlyArray<{
    readonly tag: string;
    readonly description: string;
    readonly href: string;
    readonly newTab?: boolean;
  }>;
};
